<template>
    <main id="js-page-content" class="page-content" role="main">
        <div class="flex align-center justify-center mb-5">
            <div>
                <img src="/img/desert.jpg" class="aspect-square m-auto w-100" />
                <div class="text-center">
                    <h3 class="h3">{{ $t('404.title') }}</h3>
                </div>
            </div>
        </div>

        <div class="flex align-center justify-center mt-5">
            <div class="mt-5">
                <router-link to="/" class="btn btn-primary">
                    {{ $t('404.link') }}
                </router-link>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'PageNotFound'
}
</script>

<style scoped>
img {
    clip-path: ellipse(50% 45% at 50% 65%);
    z-index: 3;
}
</style>
